/* koréos C — header behaviour (build agent F). Mega menus (hover intent + click + keyboard), sticky/hide-on-scroll,
   announcement rotation, mobile drawer + search dialog (focus trap, Esc, inert background). Cart drawer + count stay Hyper's.
   koreos SEO P1-6 (2026-10-17): the mega-panel photo cards + drawer tiles come from the Section Rendering API on the first
   hover / focus / open intent (loadCards); drawer sub-panels are built on first open from the desktop panel's text links
   (buildSub); the search dialog's link lists are filled on first open (fillSearch). Nothing else about the behaviour changed. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desk = window.matchMedia('(min-width: 1024px)');

  function init() {
    var hdr = $('#kc-hdr');
    if (!hdr || hdr.dataset.kcInit) return;
    hdr.dataset.kcInit = '1';
    var ann = $('.kc-ann');
    var scrimM = $('.kc-mscrim');

    /* ---------- header height vars (Hyper sticky elements read --header-height) ---------- */
    // final-fix 2026-10 (sticky header too tall): the desktop "Popular now" strip and the mobile chip rail sit out of
    // flow under the bar (the header keeps their height as margin-bottom, so nothing below moves when they fold away).
    // --kc-hdr-h / --header-height follow what is actually pinned on screen.
    function strip() { var s = desk.matches ? $('.kc-quick', hdr) : $('.kc-mchips', hdr); return s && s.offsetParent !== null ? s : null; }
    function setVars() {
      var s = strip(), sh = s ? s.offsetHeight : 0;
      html.style.setProperty('--kc-strip-h', sh + 'px');
      var h = hdr.offsetHeight + (hdr.classList.contains('is-compact') ? 0 : sh);
      html.style.setProperty('--header-height', h + 'px');
      html.style.setProperty('--header-navigation-height', '0px');
      html.style.setProperty('--kc-hdr-h', h + 'px');
    }
    setVars();
    if (window.ResizeObserver) { var ro = new ResizeObserver(setVars); ro.observe(hdr); $$('.kc-quick, .kc-mchips', hdr).forEach(function (x) { ro.observe(x); }); }

    /* ---------- pinned / hide on scroll down (phones and tablets) ---------- */
    var lastY = window.scrollY, ticking = false;
    function setCompact(on) {
      if (hdr.classList.contains('is-compact') === on) return;
      hdr.classList.toggle('is-compact', on);
      setVars();
    }
    function onScroll() {
      var y = window.scrollY;
      var annH = ann ? ann.offsetHeight : 0;
      var locked = html.classList.contains('kc-lock');
      var top = annH + hdr.offsetHeight + 40;
      if (!desk.matches && !locked && !openMega) {
        if (y > lastY && y > 160) hdr.classList.add('is-hidden');
        else if (y < lastY - 4 || y <= 160) hdr.classList.remove('is-hidden');
        // phones: the chip rail folds away once the page scrolls; scrolling back up brings the 56px bar, the rail
        // returns near the top of the page (a pinned 184px header was the audit finding)
        if (y > top) { if (y > lastY) setCompact(true); } else setCompact(false);
      } else {
        hdr.classList.remove('is-hidden');
        // desktop: "Popular now" hides on scroll down, shows again on scroll up
        if (!openMega && y > top && y > lastY + 2) setCompact(true);
        else if (y < lastY - 4 || y <= top) setCompact(false);
      }
      var pinned = y > annH && !hdr.classList.contains('is-hidden');
      d.body.classList.toggle('header-pinned', pinned);
      lastY = y; ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();

    /* ---------- SEO P1-6: cards + tiles from the Section Rendering API (/?view=kc-cards&section_id=<header section>) ---------- */
    var cardsState = 0, tilesHTML = {}; // 0 idle, 1 loading, 2 done, 3 failed
    function eagerImgs(el) { $$('img[loading="lazy"]', el).forEach(function (i) { i.loading = 'eager'; }); }
    function loadCards() {
      if (cardsState) return;
      cardsState = 1;
      var wrap = hdr.closest('.shopify-section');
      var sid = wrap && wrap.id ? wrap.id.replace(/^shopify-section-/, '') : '';
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (!sid || !window.fetch || !window.DOMParser) { cardsState = 3; cardsFailed(); return; }
      fetch(root + '?view=kc-cards&section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var got = $$('[data-kc-cards]', doc);
          if (!got.length) throw new Error('no cards');
          got.forEach(function (src) {
            var slot = $('[data-kc-cards-slot="' + src.getAttribute('data-kc-cards') + '"]', hdr);
            if (!slot) return;
            slot.innerHTML = src.innerHTML;
            if (slot.closest('.kc-primed')) eagerImgs(slot);
          });
          $$('[data-kc-tiles]', doc).forEach(function (src) { tilesHTML[src.getAttribute('data-kc-tiles')] = src.innerHTML; });
          cardsState = 2;
          $$('.kc-sub[data-kc-built]').forEach(fillTiles);
        })
        .catch(function () { cardsState = 3; cardsFailed(); });
    }
    function cardsFailed() { $$('.kc-ed--ph', hdr).forEach(function (x) { x.remove(); }); }
    // drawer tiles: the API tiles when they are in; until then plain tiles from the desktop panel's links (they work, images follow)
    function fillTiles(sub) {
      var slot = $('.kc-m1-tiles', sub); if (!slot) return;
      var i = sub.getAttribute('data-kc-pos');
      if (tilesHTML[i] != null) {
        if (slot.getAttribute('data-kc-filled') === 'api') return;
        var act = d.activeElement, idx = act && slot.contains(act) ? $$('a', slot).indexOf(act) : -1;
        slot.innerHTML = tilesHTML[i]; slot.setAttribute('data-kc-filled', 'api');
        if (sub.classList.contains('kc-primed')) eagerImgs(slot);
        if (idx > -1) { var n = $$('a', slot)[idx]; if (n) n.focus(); }
      } else if (!slot.hasAttribute('data-kc-filled')) {
        var mx = d.getElementById('kc-mx-' + i);
        $$('.kc-ed-links a[href]', mx).forEach(function (a) {
          var t = d.createElement('div'); t.className = 'kc-m1-tile';
          var w = d.createElement('span'); w.className = 'kc-m1-tile__img'; t.appendChild(w);
          var l = d.createElement('a'); l.className = 'kc-m1-tile__a'; l.href = a.getAttribute('href');
          var b = d.createElement('b'); b.textContent = a.textContent.trim(); l.appendChild(b); t.appendChild(l);
          slot.appendChild(t);
        });
        slot.setAttribute('data-kc-filled', 'links');
      }
    }
    // drawer sub-panel = clone of the desktop panel's chip rows + "Shop all" (no second copy in the page HTML)
    function buildSub(sub) {
      if (!sub || sub.hasAttribute('data-kc-built')) return;
      var mx = d.getElementById('kc-mx-' + sub.getAttribute('data-kc-pos'));
      if (!mx) return;
      sub.setAttribute('data-kc-built', '');
      fillTiles(sub);
      var rest = $('.kc-sub__rest', sub) || sub;
      $$('.kc-ed-foot', mx).forEach(function (f) {
        var links = $$('a[href]:not(.kc-ed-foot__find)', f); if (!links.length) return;
        var h = $('.kc-ed-foot__h', f), gh = d.createElement('p'); gh.className = 'kc-sub__gh'; gh.textContent = h ? h.textContent.trim() : '';
        var box = d.createElement('div'); box.className = 'kc-sub__chips';
        links.forEach(function (a) { var c = a.cloneNode(true); c.removeAttribute('class'); box.appendChild(c); });
        rest.appendChild(gh); rest.appendChild(box);
      });
      var all = $('.kc-ed-all', mx);
      if (all) {
        var b = d.createElement('a'); b.className = 'kc-btn kc-btn--block kc-btn--pill kc-sub__all'; b.href = all.getAttribute('href');
        b.appendChild(d.createTextNode(all.textContent.trim() + ' '));
        var ar = d.createElement('span'); ar.className = 'kc-arrow'; ar.setAttribute('aria-hidden', 'true'); ar.textContent = '\u2192'; b.appendChild(ar);
        rest.appendChild(b);
      }
    }
    // search dialog lists: "Popular now" = the header's popular row, departments = data-kc-deps (title, url pairs)
    function fillSearch(p) {
      if (!p || p.hasAttribute('data-kc-filled')) return;
      p.setAttribute('data-kc-filled', '');
      var pop = $('[data-kc-fill="pop"]', p);
      if (pop) $$('.kc-quick__row a[href]', hdr).forEach(function (a) {
        var li = d.createElement('li'), c = d.createElement('a'); c.className = 'kc-chip'; c.href = a.getAttribute('href');
        var t = $$('span', a).pop(); c.textContent = (t || a).textContent.trim(); li.appendChild(c); pop.appendChild(li);
      });
      var dep = $('[data-kc-fill="deps"]', p), arr = [];
      try { arr = JSON.parse(dep.getAttribute('data-kc-deps')) || []; } catch (e) {}
      for (var k = 0; dep && k + 1 < arr.length; k += 2) {
        var li = d.createElement('li'), a = d.createElement('a'); a.href = arr[k + 1]; a.textContent = arr[k]; li.appendChild(a); dep.appendChild(li);
      }
    }

    /* ---------- image priming: closed panels keep their (lazy) images display:none until first opened / hover intent (QA B1) ---------- */
    function prime(el) {
      if (!el) return;
      if (el.id === 'kc-search') fillSearch(el); else loadCards();
      if (el.classList.contains('kc-sub')) buildSub(el);
      if (el.classList.contains('kc-primed')) return;
      el.classList.add('kc-primed');
      $$('img[loading="lazy"]', el).forEach(function (i) { if (!i.closest('.kc-sub:not(.kc-primed)') || el.classList.contains('kc-sub')) i.loading = 'eager'; });
    }

    /* ---------- mega menus ---------- */
    var openMega = null, megaTimer;
    function focusables(el) {
      return $$('a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,summary,[tabindex]:not([tabindex="-1"])', el)
        .filter(function (x) { return x.offsetParent !== null || x === d.activeElement; })
        .filter(function (x) { var cs = getComputedStyle(x); return cs.visibility !== 'hidden' && x.tabIndex !== -1; });
    }
    function placeMega(p) {
      var b = hdr.getBoundingClientRect().bottom;
      if (scrimM) scrimM.style.top = Math.max(0, b) + 'px';
      if (p) p.style.setProperty('--kc-mx-max', Math.max(240, window.innerHeight - b - 12) + 'px');
    }
    function setMega(btn, on) {
      var p = d.getElementById(btn.getAttribute('aria-controls'));
      if (!p) return;
      if (on && openMega && openMega !== btn) setMega(openMega, false);
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      p.hidden = !on;
      if (on) openMega = btn; else if (openMega === btn) openMega = null;
      html.classList.toggle('kc-mega-open', !!openMega);
      if (on) { prime(p); placeMega(p); }
    }
    function closeLater() { clearTimeout(megaTimer); megaTimer = setTimeout(function () { if (openMega) setMega(openMega, false); }, 300); }
    $$('[data-kc-mega]', hdr).forEach(function (btn) {
      var li = btn.closest('li');
      btn.addEventListener('click', function () { clearTimeout(megaTimer); setMega(btn, btn.getAttribute('aria-expanded') !== 'true'); });
      btn.addEventListener('keydown', function (e) {
        var p = d.getElementById(btn.getAttribute('aria-controls'));
        if (e.key === 'ArrowDown' && p) { e.preventDefault(); setMega(btn, true); var f = focusables(p)[0]; if (f) f.focus(); }
      });
      var primeMine = function () { prime(d.getElementById(btn.getAttribute('aria-controls'))); };
      btn.addEventListener('focus', primeMine);
      li.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        primeMine();
        clearTimeout(megaTimer); megaTimer = setTimeout(function () { setMega(btn, true); }, openMega ? 60 : 150);
      });
      li.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') closeLater(); });
    });
    $$('.kc-mx', hdr).forEach(function (p) {
      p.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') clearTimeout(megaTimer); });
      p.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') closeLater(); });
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openMega) { var b = openMega; setMega(b, false); b.focus(); }
    });
    d.addEventListener('click', function (e) { if (openMega && !e.target.closest('#kc-hdr')) setMega(openMega, false); });
    d.addEventListener('focusin', function (e) { if (openMega && !e.target.closest('#kc-hdr')) setMega(openMega, false); });
    window.addEventListener('resize', function () { if (openMega) { if (!desk.matches) setMega(openMega, false); else placeMega(d.getElementById(openMega.getAttribute('aria-controls'))); } });

    /* ---------- drawers: mobile menu + search ---------- */
    var scrim = $('.kc-scrim'), current = null, lastFocus = null, inerted = [];
    function inertOthers(panel) {
      var el = panel;
      while (el && el !== d.body) {
        var parent = el.parentElement;
        Array.prototype.forEach.call(parent.children, function (c) {
          if (c === el || c === scrim || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(c.tagName) || c.hasAttribute('inert')) return;
          if (getComputedStyle(c).display === 'contents') return; // handled when walking down
          c.setAttribute('inert', ''); inerted.push(c);
        });
        el = parent;
      }
      // section wrappers are display:contents: inert their other children too
      $$('.kc-hdr-section > *').forEach(function (c) { if (c !== panel && c !== scrim && !c.contains(panel) && !c.hasAttribute('inert') && !/^(SCRIPT|STYLE|svg)$/i.test(c.tagName)) { c.setAttribute('inert', ''); inerted.push(c); } });
    }
    function openPanel(id, opener) {
      var p = d.getElementById(id); if (!p) return;
      if (current) closePanel(true);
      if (openMega) setMega(openMega, false);
      lastFocus = opener || d.activeElement; current = p;
      prime(p);
      p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false');
      $$('[aria-controls="' + id + '"][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (p.classList.contains('kc-panel')) scrim.classList.add('is-on');
      html.classList.add('kc-lock'); d.body.style.overflow = 'hidden';
      inertOthers(p);
      setTimeout(function () {
        var f = id === 'kc-search' ? $('input[type="search"]', p) : null;
        f = f || focusables(p)[0];
        if (f) f.focus();
      }, 60);
    }
    function closePanel(silent) {
      if (!current) return;
      var id = current.id;
      current.classList.remove('is-open'); current.setAttribute('aria-hidden', 'true');
      $$('.kc-sub.is-open', current).forEach(function (s) { s.classList.remove('is-open'); });
      $$('[data-kc-sub][aria-expanded="true"]', current).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      $$('[aria-controls="' + id + '"][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      scrim.classList.remove('is-on'); html.classList.remove('kc-lock'); d.body.style.overflow = '';
      inerted.forEach(function (x) { x.removeAttribute('inert'); }); inerted = [];
      current = null;
      if (!silent && lastFocus && d.contains(lastFocus)) lastFocus.focus();
    }
    function scopeOf(panel) {
      var sub = $('.kc-sub.is-open', panel);
      return sub ? focusables($('.kc-panel__hd', panel)).concat(focusables(sub)) : focusables(panel);
    }
    d.addEventListener('click', function (e) {
      var o = e.target.closest('[data-kc-open]');
      if (o) { e.preventDefault(); openPanel(o.getAttribute('data-kc-open'), current && current.contains(o) ? lastFocus : o); return; }
      if (current && (e.target.closest('[data-kc-close]') || e.target === scrim)) { e.preventDefault(); closePanel(); return; }
      var s = e.target.closest('[data-kc-sub]');
      if (s) {
        var sub = d.getElementById(s.getAttribute('data-kc-sub'));
        if (sub) { prime(sub); sub.classList.add('is-open'); s.setAttribute('aria-expanded', 'true'); setTimeout(function () { var b = $('.kc-sub__back', sub); if (b) b.focus(); }, 60); }
        return;
      }
      var back = e.target.closest('.kc-sub__back');
      if (back) {
        var sb = back.closest('.kc-sub'); sb.classList.remove('is-open');
        var t = $('[data-kc-sub="' + sb.id + '"]'); if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
      }
    });
    d.addEventListener('keydown', function (e) {
      if (!current) return;
      if (e.key === 'Escape') {
        var sub = $('.kc-sub.is-open', current);
        if (sub) { $('.kc-sub__back', sub).click(); return; }
        closePanel(); return;
      }
      if (e.key === 'Tab') {
        var f = scopeOf(current); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (f.indexOf(d.activeElement) === -1) { e.preventDefault(); first.focus(); return; }
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    // hover / touch intent on drawer openers and sub-panel triggers warms their images a beat early
    d.addEventListener('pointerover', function (e) {
      var t = e.target.closest && e.target.closest('[data-kc-open],[data-kc-sub]'); if (!t) return;
      prime(d.getElementById(t.getAttribute('data-kc-open') || t.getAttribute('data-kc-sub')));
    }, { passive: true });
    d.addEventListener('touchstart', function (e) {
      var t = e.target.closest && e.target.closest('[data-kc-open],[data-kc-sub]'); if (!t) return;
      prime(d.getElementById(t.getAttribute('data-kc-open') || t.getAttribute('data-kc-sub')));
    }, { passive: true });
    desk.addEventListener && desk.addEventListener('change', function () { if (current && current.id === 'kc-menu' && desk.matches) closePanel(true); setCompact(false); setVars(); });
    // a cart drawer opened from inside our drawer (or anywhere) closes ours first
    $$('[aria-controls="CartDrawer"]').forEach(function (b) { b.addEventListener('click', function () { if (current) closePanel(true); }, true); });

    /* ---------- announcement rotation (phones; pausable; off for reduced motion) ---------- */
    (function () {
      var list = $('.kc-ann__list'); if (!list) return;
      var items = $$('li', list), i = 0, btn = $('.kc-ann__pause'), paused = reduce, hover = false;
      if (items.length < 2) return;
      function tick() { if (paused || hover || desk.matches || d.hidden) return; items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }
      setInterval(tick, 4500);
      function sync() { if (!btn) return; btn.setAttribute('aria-pressed', paused ? 'true' : 'false'); btn.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements'); }
      sync();
      if (btn) btn.addEventListener('click', function () { paused = !paused; sync(); });
      list.addEventListener('mouseenter', function () { hover = true; }); list.addEventListener('mouseleave', function () { hover = false; });
      list.addEventListener('focusin', function () { hover = true; }); list.addEventListener('focusout', function () { hover = false; });
    })();
  }
  /* final-fix 2026-10 P0: Shopify Inbox bubble (shopify-chat, icon-only via ::part in koreos-c) waits until the page has
     scrolled past the first screen, so it never sits on the hero card, the first card row or a "Shop all" link at load.
     Short pages (and the bottom of any page) show it straight away. On PDPs kc-pages.js adds the sticky-bar lift. */
  function chatDock() {
    var t = false, used = false;
    /* once the shopper has used the bubble, never hide it again (the open chat window must not vanish on scroll-up) */
    d.addEventListener('click', function (e) { var p = e.composedPath ? e.composedPath() : []; for (var i = 0; i < p.length; i++) if (p[i].tagName === 'SHOPIFY-CHAT') { used = true; html.classList.remove('kc-chat-wait'); return; } }, true);
    function upd() {
      t = false;
      if (used) return;
      var y = window.scrollY, h = window.innerHeight, H = html.scrollHeight;
      var show = y > h * 1.1 || H < h * 1.6 || y + h > H - 120;
      html.classList.toggle('kc-chat-wait', !show);
    }
    html.classList.add('kc-chat-wait');
    /* theme fix 2: while the footer's bottom bar (legal links, Instagram) is on screen, the bubble rides above it */
    var bot = d.querySelector('.kc-ftr__bot');
    if (bot && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { html.style.setProperty('--kc-ftr-bot-h', Math.min(bot.offsetHeight, 220) + 'px'); html.classList.toggle('kc-chat-foot', en[0].isIntersecting); }).observe(bot);
    window.addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd);
    window.addEventListener('load', upd);
    upd();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', chatDock); else chatDock();
  function footer() { if (desk.matches) $$('.kc-ftr__col details').forEach(function (x) { x.open = true; }); }
  desk.addEventListener && desk.addEventListener('change', footer);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', footer); else footer();
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector && e.target.querySelector('#kc-hdr')) init(); });
})();
